"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadPayload = void 0;
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
// import { hexStringToArrayBuffer, splitArrayIntoChunks } from '../../../../utils/conversions';
var await_timeout_1 = __importDefault(require("await-timeout"));
var DeviceCharacteristic_1 = require("../../../../common/DeviceCharacteristic");
var MSSProgressState_1 = require("../../../../bluetoothClient/MSSProgressState");
var payloadUploaded = false;
var uploadPayload = function (device) { return __awaiter(void 0, void 0, void 0, function () {
    var chunk, result, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 7]);
                if (!!payloadUploaded) return [3 /*break*/, 3];
                if (!(device.payloadUploadState.uploaded === device.payloadUploadState.chunks)) return [3 /*break*/, 3];
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.PayloadUploaded);
                return [4 /*yield*/, device
                        .writeCharacteristicValues((_a = device.profile) === null || _a === void 0 ? void 0 : _a.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.CONTROL; }).uuid, Uint8Array.of(3), // 3 indicates device that all chunks have been uploaded.
                    false)
                        .then(function () {
                        payloadUploaded = true;
                    })];
            case 1:
                _b.sent();
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.ConfirmAllPayloadUploaded);
                return [4 /*yield*/, await_timeout_1.default.set(2000).then(function () {
                        payloadUploaded = false;
                    })];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                if (!(device.payloadUploadState.uploaded < device.payloadUploadState.chunks)) return [3 /*break*/, 5];
                device.payloadUploadState.uploaded === 0 &&
                    device.mssProgressChanged(MSSProgressState_1.MSSProgressState.StartPayloadUpload);
                chunk = device.parsedPayload.payload[device.payloadUploadState.uploaded];
                return [4 /*yield*/, device.writeCharacteristicValues(device.profile.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.PAYLOAD; }).uuid, chunk, false)];
            case 4:
                _b.sent();
                device.payloadUploadState = __assign(__assign({}, device.payloadUploadState), { uploaded: device.payloadUploadState.uploaded + 1 });
                result = Math.round((device.payloadUploadState.uploaded / device.payloadUploadState.chunks) * 100);
                // Update payload upload progress
                device.payloadUploadChanged({ progress: result });
                _b.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                error_1 = _b.sent();
                return [2 /*return*/, error_1];
            case 7: return [2 /*return*/];
        }
    });
}); };
exports.uploadPayload = uploadPayload;
